import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NgxAuthComponent } from './@theme/components/auth';
import { NgxLoginComponent } from './@theme/components/auth/login/login.component';
import { NgxLogoutComponent } from './@theme/components/auth/logout/logout.component';
import { NgxRegisterComponent } from './@theme/components/auth/register/register.component';
import { NgxRequestPasswordComponent } from './@theme/components/auth/request-password/request-password.component';
import { NgxResetPasswordComponent } from './@theme/components/auth/reset-password/reset-password.component';
import { RedirectComponent } from './redirect/redirect.component';

import { AdminRouteGuard } from './admin-route-guard';
import { ManagerRouteGuard } from './manager-route-guard';
import { UserRouteGuard } from './user-route-guard';

const routes: Routes = [
  {
    path: 'redirect',
    component: RedirectComponent,
  },
  {
    path: 'user',
    loadChildren: 'app/user/user.module#UserModule',
    canActivate: [ UserRouteGuard ],
  },
  {
    path: 'manager',
    loadChildren: './manager/manager.module#ManagerModule',
    canActivate: [ ManagerRouteGuard ],
  },
  {
    path: 'admin',
    loadChildren: './pages/pages.module#PagesModule',
    canActivate: [ AdminRouteGuard ],
  },
  {
    path: 'auth',
    component: NgxAuthComponent,
    children: [
      {
        path: '',
        component: NgxLoginComponent,
      },
      {
        path: 'login',
        component: NgxLoginComponent,
      },
      {
        path: 'register',
        component: NgxRegisterComponent,
      },
      {
        path: 'logout',
        component: NgxLogoutComponent,
      },
      {
        path: 'request-password',
        component: NgxRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NgxResetPasswordComponent,
      },
    ],
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, config),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
